import styled from "styled-components";
import { FlexRowDiv } from "./common.styles";
import { HXSectionCard, SemiBoldText, LightText, LighterText } from "./HXDesktopPage.styles";
import { multilineEllipsis } from "./base.styles";
import { ContentContainer as SharedContentContainer } from "./HealthSystemShared.styles";
import { ChartJSLineChart } from "./ChartJSCharts";
export const ContentContainer = styled(SharedContentContainer) ``;
export const RequestApprovalsContainer = styled(FlexRowDiv) `
    align-self: stretch;
    gap: 24px;
`;
export const RequestApprovalsCard = styled(HXSectionCard).attrs({ isSunsetColor: true }) `
    box-sizing: border-box;
    display: flex;
    width: calc(50% - 12px);
    height: 215px;
    padding: 24px;
    justify-content: space-between;
    align-items: flex-start;
    flex-shrink: 0;
    overflow: hidden;
    cursor: pointer;
`;
export const RequestApprovalsTitle = styled(SemiBoldText) `
    ${multilineEllipsis(2)}
`;
export const RequestApprovalsSponsorText = styled(LightText) `
    ${multilineEllipsis(1)}
`;
export const RequestApprovalsConditionsAndDiseases = styled(LighterText) `
    ${multilineEllipsis(2)}
`;
export const LineChart = styled(ChartJSLineChart) `
    width: 100%;
    height: 414px;
`;
